import React, {useState} from 'react';
import styled from 'styled-components/native';
import { View, Text, Pressable } from 'react-native';
import { Link } from 'app/src/utils/routing';
import { elLightGray } from '../../../styles/colors';
import { useLocation } from 'react-router-dom';
import Modal from '../../../elements/Modal';
import NewSellerUser from './new';
import { SubNavContainer } from '../../../elements';

// const NavbarContainer = styled(View)`
//   display: flex;
//   flex-direction: row;
//   justify-content: space-between;
//   flex: 0.25;
//   align-items: center;
//   height: 5px;
//   background-color: ${elLightGray};
//   padding: 15px;
//   padding-left: 50px;
// `;

const SubNav = ({refetch, user, sellerId}) => {
  const [showAddSellerUserModal, setShowAddSellerUserModal] = useState(false);
  const location = useLocation();
  return (
    <SubNavContainer>
      {getLinks()}
    </SubNavContainer>
  )

  function getLinks() {
    if(location.pathname === `/sellers/${sellerId}/users`) {
      return (
        <View>
          <Pressable
            onPress={() => setShowAddSellerUserModal(true)}
          >
            <Text>+ Add Seller User</Text>
          </Pressable>
          {showAddSellerUserModal &&
            <Modal
              setShowModal={setShowAddSellerUserModal}
              modalType={'Add Seller User'}
            >
              <NewSellerUser
                setShowModal={setShowAddSellerUserModal}
                knownSellerId={sellerId}
                refetch={refetch}
              />
            </Modal>
          }
        </View>
      )
    }else if(location.pathname === '/sellerUsers/new') {
      return (
        <Link to={`/sellers/${sellerId}/users`}>
          <Text>Seller Users</Text>
        </Link>
      )
    }
    // else {
    //   return (
    //     <Link to={`seller/${sellerId}/sellerUsers/new`}>
    //       <Text>+ Add Seller User</Text>
    //     </Link>
    //   )
    // }
  }
}

export default SubNav;
